import WygenerowaneGetList from './wygenerowaneGetList'
const data = () => {
    return WygenerowaneGetList();  
};
export default data;